import {BoxProps, ButtonProps, Text, Box, TextProps} from '@chakra-ui/react';
import Link from 'next/link';
import {theme} from '../../style/theme';

export interface LinkButtonProps {
  buttonWrapperStyles?: BoxProps['sx'];
  textStyles?: TextProps['sx'];
  buttonBgColor?: ButtonProps['bgColor'];
  buttonText?: string;
  buttonHref?: string;
  isActive?: boolean;
}

export const LinkButton: React.FC<LinkButtonProps> = ({
  buttonWrapperStyles,
  textStyles,
  buttonBgColor = theme.colors.peach,
  buttonText = 'Buy Pieces',
  buttonHref = '/',
  isActive = false,
}: LinkButtonProps) => {
  return (
    <Box
      sx={{
        color: 'white',
        textAlign: 'center',
        borderRadius: '14px',
        ...buttonWrapperStyles,
      }}
      bgColor={buttonBgColor}
      _hover={{
        background: buttonBgColor,
        opacity: '0.9',
      }}
    >
      <Link href={buttonHref}>
        <a style={{lineHeight: 0}}>
          <Text
            sx={{
              textStyle: {base: 'body3_1c', lg: 'button_1c'},
              ...textStyles,
            }}
            pb="8px"
            borderBottom="3px solid"
            borderColor={isActive ? 'white' : 'transparent'}
          >
            {buttonText}
          </Text>
        </a>
      </Link>
    </Box>
  );
};
